import React from "react";
import { ArrowUpOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { isVisible } from "@testing-library/user-event/dist/utils";

const GoToTop = () => {
    const [isVisible, setIsVisible] = useState(false);
  const goToBtn = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  const listenToScroll = () => {



    let heightToHidden = 250;
    const winScroll = document.body.scrollTop || document.documentElement.scrollTop;

    if(winScroll > heightToHidden) {
        setIsVisible(true);
    } else {

        setIsVisible(false);

    }
  }

  useEffect(() => {
    window.addEventListener('scroll', listenToScroll)
    return () => window.removeEventListener("scroll", listenToScroll)
  }, [])

  return (
    <>

      <section className="top-btn-wrap">
      {isVisible && (
        <div className="top-scroll-btn" onClick={goToBtn}>
          <ArrowUpOutlined />
         
        </div>
      )}
       
      </section>

    </>
  );
};

export default GoToTop;
